/**
 * Styled Components - Created by eduardoquintero on 18/02/20.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import Spin from 'antd/lib/spin'
import AntdIcon from 'antd/lib/icon'
import {
  BLACK,
  WHITE,
  GRAY_LIGHTEST,
  GRAY_LIGHT,
  GRAY_SKELETON
} from '../../theme/colors'

export const MainContainer = styled.div`
  background: ${WHITE};
  margin-top: -40px;
  padding-top: 34px;
  padding-bottom: 30px;
  position: relative;
  font-family: Avenir;
  p {
    color: #000;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    @media (max-width: 698px) {
      margin-inline: 4%;
    }
    span {
      color: #2196F3;
      font-size: 14px;
      font-weight: 600;
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
  p:has(span) {
    margin-top: -10px;
    margin-bottom: 20px;
  }
`

export const Container = styled.div`
  justify-content: center;
  display: flex;
  width: 100%;
  padding-bottom: 34px;
  animation: fade-in-top 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @media (max-width: 698px) {
    flex-wrap: wrap;
    padding: 0 10px;
  }
`

export const TeamStoreCreator = styled.div`
  display: flex;
`

export const StyledSpin = styled(Spin)`
  position: fixed !important;
  width: 100%;
`

export const LoadingContainer = styled.div`
  width: 100%;
  align-items: center;
  padding-top: 48px;
  justify-content: center;
  padding-bottom: 50px;
  display: flex;
  align-items: center;
`

export const ImageSkeleton = styled.div`
  width: 380px;
  min-height: 608px;
  margin-top: 24px;
  opacity: 0.6;
  margin-bottom: 18px;
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  background: ${GRAY_SKELETON};
  &:last-child {
    margin-left: 30px;
  }
  @media (min-width: 320px) and (max-width: 748px) {
    &:last-child {
      margin-left: 0px;
      margin-top: 32px;
    }
  }
`

export const Title = styled.div`
  margin: 40px 0px 12px 0px;
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
  @media (max-width: 1024px) {
    margin-top: 22px;
  }
  @media (min-width: 320px) and (max-width: 748px) {
    margin: 26px 20px;
    margin-top: 22px;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: ${WHITE};
  width: 340px;
  margin-left: 30px;
  transition: all 0.25s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 3px 11px 1px rgba(0, 0, 0, 0.15);
  }
  &:first-child {
    margin-left: 0px;
  }
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  position: relative;
  @media (max-width: 1280px) {
    width: 268px;
  }
  @media (max-width: 768px) {
    width: auto;
    flex: 1;
  }
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 42px;
    &:first-child {
      margin-top: 0px;
    }
  }
`

export const CardBadge = styled.img`
  max-width: 96px;
  position: absolute;
  left: calc(50% - 48px);
  top: -20px;
  box-shadow: 0px -1px 3px -1px #a3a3a3;
  border-radius: 3px;
`

export const CardTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  color: ${BLACK};
  background: ${GRAY_LIGHTEST};
  text-align: center;
  padding: 8px;
`

export const TeamStoreCardsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 320px) and (max-width: 748px) {
    flex-flow: column;
  }
`

export const List = styled.ul`
  padding: 0;
  margin: 0 28px;
  list-style: none;
  text-align: center;
  line-height: 1.1;
  font-size: 12.5px;
  @media (max-width: 1280px) {
    font-size: 11px;
  }
  @media (max-width: 698px) {
    line-height: 1;
  }
`

export const ListNormal = styled.ul`
  padding: 0;
  max-width: 242px;
  margin: 0 auto;
  font-family: Avenir;
  font-weight: 500;
`

export const Item = styled.li`
  margin-bottom: 10px;
`

export const PaymentIcons = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin: 0 30px;
  height: 40px;
  margin-bottom: 22px;
`

export const Icon = styled.img`
  width: 100%;
  max-width: 90px;
  margin-right: 16px;
`

export const SelectTeamStoreButton = styled(Button)`
  height: 40px;
  border: 1.5px solid #131112;
  border-radius: 22px;
  background-color: ${WHITE};
  color: #302628;
  font-weight: 600;
  min-width: 250px;
  margin: 0 auto;
  margin-bottom: 28px;
  transition: background-color .25s, color .25s;
  &:hover {
    border-color: #131112;
    background-color: #131112;
    color: white;
  }
`

export const TeamBanner = styled.img`
  max-width: 160px;
  width: 100%;
  margin-bottom: 4px;
`

export const TeamImage = styled.img`
  width: 100%;
  object-fit: cover;
  margin-bottom: 20px;
  height: 154px;
  @media (max-width: 1280px) {
    height: 114px;
  }
  @media (max-width: 698px) {
    height: 100x;
  }
`

export const TeamImageFixed = styled.img`
  width: 100%;
  object-fit: contain;
  margin-bottom: 20px;
  height: 154px;
  padding: 22px;
  background: #f1f4f5;
  @media (max-width: 1280px) {
    height: 114px;
  }
  @media (max-width: 698px) {
    height: 100px;
    padding: 12px;
  }
`

export const PaymentMethodsText = styled.div`
  text-align: center;
  margin-top: 6px;
  margin-bottom: 10px;
`

export const BottomSection = styled.div`
  flex: 1;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 24px;
`

export const BottomImage = styled.img`
  max-width: 220px;
`

export const CardNormal = styled.div`
  display: flex;
  flex-direction: column;
  background: ${WHITE};
  min-height: 588px;
  width: 340px;
  margin-left: 30px;
  transition: all 0.25s;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    box-shadow: 0 3px 11px 1px #00000033;
  }
  &:first-child {
    margin-left: 0px;
  }
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  position: relative;
  @media (max-width: 1280px) {
    width: 268px;
  }
  @media (max-width: 768px) {
    width: auto;
    flex: 1;
  }
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 42px;
    &:first-child {
      margin-top: 0px;
    }
  }
  #caption {
    color: #000;
    text-transform: uppercase;
    text-align: center;
    font-size: 16px;
    font-style: italic;
    font-weight: 700;
  }
`

export const CardTitleNormal = styled.div`
  border-radius: 7px 7px 0 0;
  background: ${GRAY_LIGHTEST};
  text-align: center;
  padding: 10px;
`

export const TeamBannerNormal = styled.img`
  max-width: 220px;
  width: 100%;
  margin-bottom: 4px;
`

export const TeamImageNormal = styled.img`
  width: 100%;
  object-fit: cover;
  margin-bottom: 12px;
  height: 200px;
  object-position: 0 20%;
`

export const FAQSection = styled.div`
  text-align: center;
`

export const FAQBody = styled.div`
  padding: 30px;
  padding-bottom: 10px;
  max-width: 1148px;
  margin: 0 auto;
  text-align: left;
  max-height: 90vh;
  @media (max-width: 698px) {
    padding-bottom: 110px;
  }
  b {
    display: block;
  }
`

export const StickyArrow = styled(AntdIcon)`
  margin-left: 12px;
  font-size: 16px;
  border-radius: 25px;
  background: #ededed;
  color: #272727;
  padding: 2px;
  padding-top: 1px;
`

export const TitleFaq = styled.div`
  color: #ededed;
  font-size: 24px;
  fony-family: Avenir;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 33px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 30px;
  position: absolute;
  top: ${({ secondary }: { secondary: boolean }) => secondary ? '-34px' : '0px'};
  left: calc(50vw - 148px);
  background: #272727;
  width: auto;
  margin: 0 auto;
  padding: 1px 32px;
  font-size: 15px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  box-shadow: 0px -1px 4px -1px #828282;
  display: flex;
  align-items: center;
  padding-right: 18px;
  left: 50%;
  margin-right: -50%;
  transform: translateX(-50%);
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 698px) {
    box-shadow: 0px -1px 4px -1px #646464;
  }
  animation: fade-in-bottomfaq 0.35s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-bottomfaq {
    0% {
      transform: translateY(10px) translateX(-50%);
      opacity: 0;
    }
    100% {
      transform: translateY(0) translateX(-50%);
      opacity: 1;
    }
  }
`

export const QuestionsDirect = styled.div`
  display: flex;
  flex-flow: column;
  padding: 0 20px;
  max-width: 1108px;
  margin: 0 auto;
  margin-top: 8px;
  margin-bottom: 30px;
  font-size: 15px;
  font-family: Avenir;
  @media (max-width: 1024px) {
    padding: 0 40px;
  }
`

export const QuestionTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 14px;
`

export const QuestionsBody = styled.div``

export const BackToList = styled.div`
  position: absolute;
  left: 78px;
  top: 74px;
  border: 1px solid #302628;
  color: #302628;
  padding: 6px 10px;
  border-radius: 3px;
  font-size: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: #302628;
    color: ${WHITE};
  }
  animation: fade-in-top 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @media (max-width: 1024px) {
    position: unset;
    width: fit-content;
    margin: 0 auto;
    margin-top: 24px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/TeamstoreTypes/styledComponents.tsx